export default {
  box: 'Box',
  prio: 'Priorita',
  comment: 'Komentár',
};
